import { create } from "zustand";

/** Papers the user just went to fetch through their library, with Zotero
 * connected: paperId → when the watch started (ms). The PDF row watches
 * for the Zotero-saved PDF while an entry is fresh. Lives outside the row
 * because the row remounts whenever the paper's PDF status changes.
 *
 * `lastCheckAt` is when any watch last asked the server to check Zotero, so
 * every row's ticks, tab-focus checks and "Check now" share the server's
 * 1-per-30s limit instead of colliding with it. */
interface State {
  startedAt: Record<string, number>;
  lastCheckAt: number;
  start: (paperId: string) => void;
  stop: (paperId: string) => void;
  markChecked: () => void;
}

export const useZoteroWatchStore = create<State>((set) => ({
  startedAt: {},
  lastCheckAt: 0,
  start: (paperId) =>
    set((s) => ({ startedAt: { ...s.startedAt, [paperId]: Date.now() } })),
  stop: (paperId) =>
    set((s) => {
      if (!(paperId in s.startedAt)) return s;
      const rest = { ...s.startedAt };
      delete rest[paperId];
      return { startedAt: rest };
    }),
  markChecked: () => set({ lastCheckAt: Date.now() }),
}));
